"use client";
import { useEffect } from "react";

const GoogleFundingIframe = () => {
  useEffect(() => {
    function signalGooglefcPresent() {
      if (!window.frames["googlefcPresent"]) {
        if (document.body) {
          const iframe = document.createElement("iframe");
          iframe.style.cssText =
            "width: 0; height: 0; border: none; z-index: -1000; position: absolute; left: -1000px; top: -1000px; display: none;";
          iframe.name = "googlefcPresent";
          document.body.appendChild(iframe);
        } else {
          setTimeout(signalGooglefcPresent, 0);
        }
      }
    }

    signalGooglefcPresent();
  }, []);

  return null;
};

export default GoogleFundingIframe;
